function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCaretRight = function SvgIconCaretRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    d: "m8.5 20.496 7.5-7.5-7.5-7.5"
  }));
};
export default SvgIconCaretRight;